var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 217,
    viewBox: "0 0 217 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 108.5,
    cy: 108.5,
    r: 103.5,
    stroke: "#2FD159",
    strokeOpacity: 0.14,
    strokeWidth: 10
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 108,
    r: 80.5,
    stroke: "#2FD159",
    strokeOpacity: 0.2,
    strokeWidth: 15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.5 43.0833C72.4555 43.0833 43.0834 72.4553 43.0834 108.5C43.0834 144.545 72.4555 173.917 108.5 173.917C144.545 173.917 173.917 144.545 173.917 108.5C173.917 72.4553 144.545 43.0833 108.5 43.0833ZM139.769 93.4541L102.678 130.545C101.762 131.461 100.519 131.985 99.2109 131.985C97.9025 131.985 96.6596 131.461 95.7438 130.545L77.2309 112.032C75.3338 110.135 75.3338 106.995 77.2309 105.098C79.128 103.201 82.268 103.201 84.165 105.098L99.2109 120.144L132.835 86.5199C134.732 84.6228 137.872 84.6228 139.769 86.5199C141.666 88.417 141.666 91.4916 139.769 93.4541Z",
    fill: "#22B348"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.43e9e9cb66134b39f8cab3f4d4515157.svg";
export { ForwardRef as ReactComponent };